<template>
  <a-spin :spinning="confirmLoading">
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="6">
            <a-form-item label="禽苗数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['chickQty', validatorRules.chickQty]" placeholder="请输入禽苗数量（羽）" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="死淘数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['deadQty', validatorRules.deadQty]" placeholder="请输入死淘数量" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="赠送数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['giftQty']" placeholder="请输入赠送数量" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.amountOfDoc')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['chickAmount', validatorRules.chickAmount]" placeholder="请输入禽苗金额（元）" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.feedConsumption')":labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['feedConsume', validatorRules.feedConsume]" placeholder="请输入饲料耗用量（吨）" style="width: 84%"/> 件
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.amountOfFeed')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['feedAmount', validatorRules.feedAmount]" placeholder="请输入饲料金额（元）" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="药品耗用量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['drugConsume', validatorRules.drugConsume]" placeholder="请输入药品耗用量（瓶/包/袋等）" style="width: 84%"/> 袋
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="药品金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['drugAmount', validatorRules.drugAmount]" placeholder="请输入药品金额（元）" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="疫苗耗用量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['vaccineConsume', validatorRules.vaccineConsume]" placeholder="请输入疫苗耗用量（瓶）" style="width: 84%"/> 瓶
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="疫苗金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['vaccineAmount', validatorRules.vaccineAmount]" placeholder="请输入疫苗金额（元）" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.totalAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['totalAmount', validatorRules.totalAmount]" placeholder="请输入合计金额（元）" style="width: 84%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item v-has="'conCode'" :label="$t('label.contracts')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="耗用明细" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="viewEfsStlConsumeTable.loading"
          :columns="viewEfsStlConsumeTable.columns"
          :dataSource="viewEfsStlConsumeTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'

  export default {
    name: 'ConsumeInfoForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props:{
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
          chickQty: {
            rules: [
              { required: true, message: '请输入禽苗数量!'},
              { pattern: /^-?\d+$/, message: '请输入整数!'},
            ]
          },
          deadQty: {
            rules: [
              { required: true, message: '请输入禽苗数量!'},
              { pattern: /^-?\d+$/, message: '请输入整数!'},
            ]
          },
          chickAmount: {
            rules: [
              { required: true, message: '请输入禽苗金额!'},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          feedConsume: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          feedAmount: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          vaccineConsume: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          vaccineAmount: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          drugConsume: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          drugAmount: {
            rules: [
              { required: false},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
        },
        refKeys: ['viewEfsStlConsume', ],
        tableKeys:['viewEfsStlConsume', ],
        activeKey: 'viewEfsStlConsume',
        // view_efs_stl_consume
        viewEfsStlConsumeTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: this.$t('tableHeader.materialCategory'),
              key: 'mmCategoryCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '物料类别名称',
              key: 'mmCategoryName',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.materialCode'),
              key: 'mmCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.materialName'),
              key: 'mmName',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.quantity'),
              key: 'pricingQty',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.unitPrice'),
              key: 'unitPrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '金额',
              key: 'subtotal',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },

            {
              title: this.$t('tableHeader.specification'),
              key: 'mmSpec',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          viewEfsStlConsume: {
            list: '/settleList/efsStlSettle/queryViewEfsStlConsumeByMainId'
          },
        }
      }
    },

    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      }
    },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("ConsumeInfoForm-edit",this.model);
        let fieldval = pick(this.model,'conCode','chickQty','deadQty','giftQty','chickAmount','feedConsume','feedAmount','vaccineConsume','vaccineAmount','drugConsume','drugAmount','totalAmount')
        // 加载子表数据
        if (this.model.id) {
          let params = { conCode: this.model.conCode }
          this.requestSubTableData(this.url.viewEfsStlConsume.list, params, this.viewEfsStlConsumeTable)
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError","结算单详情表单校验未通过");
          }
        })
        console.log("结算单详情表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'chickQty','deadQty','giftQty','chickAmount','feedConsume','feedAmount','vaccineConsume','vaccineAmount','drugConsume','drugAmount','totalAmount'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
    }
  }
</script>
